import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 用户端:v3模块
const routerV3 = {
  path: '/v3',
  name: 'v3',
  redirect: '/v3/todo',
  component: () =>
    import('@/views/V3/index.vue'),
  children: [
    {
      path: 'todo',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/todo.vue')
    },
    {
      path: 'timeout',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/timeout.vue')
    },
    {
      path: 'sent',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/sent.vue')
    }, {
      path: 'init',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/init.vue')
    },
    {
      path: 'did',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/did.vue')
    },
    {
      path: 'copy',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/copy.vue')
    },
    {
      path: 'handover',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/handover.vue')
    },
    {
      path: 'fav',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/fav.vue')
    },
    {
      path: 'classes',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/V3/list/classes.vue')
    },

  ]


};

// 管理端:admin模块
const routerAdmin = {
  path: '/admin',
  name: 'admin',
  // redirect: '/admin/index',
  component: () =>
    import('@/views/admin/index.vue'),
  children: [
    {
      path: 'home',
      meta: {
        title: '首页',
      },
      component: () =>
        import('@/views/admin/home/index.vue')
    },
    {
      path: 'index',
      meta: {
        title: '首页',
      },
      component: () =>
        import('@/views/admin/home/index.vue')
    },
    {
      path: 'delete',
      meta: {
        title: '待办隐藏',
      },
      component: () =>
        import('@/views/admin/delete/index.vue')
    },
    {
      path: 'compare',
      meta: {
        title: '待办反查',
      },
      component: () =>
        import('@/views/admin/compare/index.vue')
    },
    {
      path: 'deleteProcess',
      meta: {
        title: '流程删除',
      },
      component: () =>
        import('@/views/admin/deleteProcess/index.vue')
    },
    {
      path: 'pushRecord',
      meta: {
        title: '流程日志',
      },
      component: () =>
        import('@/views/admin/pushRecord/index.vue')
    },
    {
      path: 'thirdFailure',
      meta: {
        title: '失败下游待办',
      },
      component: () =>
        import('@/views/admin/thirdFailure/index.vue')
    },
    {
      path: 'businessModule',
      meta: {
        title: '业务系统管理',
      },
      component: () =>
        import('@/views/admin/businessModule/index.vue')
    },
    {
      path: 'processSettings',
      meta: {
        title: '流程属性设置',
      },
      component: () =>
        import('@/views/admin/processSettings/index.vue')
    },
    {
      path: 'processApproveSettings',
      meta: {
        title: '流程审批设置',
      },
      component: () =>
        import('@/views/admin/processApproveSettings/index.vue')
    },
    {
      path: 'templateManage',
      meta: {
        title: '模板管理',
      },
      component: () =>
        import('@/views/admin/templateManage/index.vue')
    },
    {
      path: 'legacyAccess',
      meta: {
        title: '交接设置',
      },
      component: () =>
        import('@/views/admin/legacyAccess/index.vue')
    }
  ]


};


// 管理端:exchange模块
const routerExchange = {
  path: '/exchange',
  name: 'exchange',
  // redirect: '/exchange/client',
  component: () =>
    import('@/views/exchange/index.vue'),
  children: [
    {
      path: 'client',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/exchange/client/index.vue')
    },
    {
      path: 'log',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/exchange/log/index.vue')
    },
    {
      path: 'moduleMap',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/exchange/moduleMap/index.vue')
    },
    {
      path: 'userMap',
      meta: {
        title: '',
      },
      component: () =>
        import('@/views/exchange/userMap/index.vue')
    },
  ]
};


const routes = [
  {
    path: '/todo-center',
    alias: '/ai-workbench',
    name: 'todo-center',
    meta: {
      title: 'AI采购协同空间',
    },
    component: () =>
      import('@/views/ai-workbench/index.vue')
  },
  routerV3,
  routerAdmin,
  routerExchange,
  //
  {
    path:'/processMonitor',
    meta: {
      title: '',
    },
    component: () =>
      import('@/views/admin/deleteProcess/index.vue')
  },
  {
    path: '/V2.1',
    name: 'V2.1',
    meta: {
      title: '待办中心',
    },
    component: () =>
      import('@/views/V2.1/index.vue')
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      title: 'TEST',
    },
    component: () =>
      import('@/views/test/index.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'HOME',
    },
    component: () =>
      import('@/views/home/index.vue')
  },
  {
    path: '*', // 从上往下找 不存在时
    redirect: '/todo-center'
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL, //应用的基路径
  routes
})

//连续点击多次路由报错解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
